module.exports = __webpack_public_path__ + "static/urban14-34352eed61ae5f45335b827102646b40.jpg";